/* Stroomkaart - translations: audience pages (bouwers, evenementen, film, gemeenten, bedrijven, laadpalen)
   ============================================ */

/* eslint-disable @typescript-eslint/no-explicit-any */
export const nl = {
  /* ----- Voor-pagina's (doelgroep) ----- */
  voor_bouwers: {
    title: 'Voor aannemers - Stroomkaart',
    eyebrow: 'Voor aannemers',
    h1: 'Tijdelijke bouwstroom zonder wachttijd.',
    lede: 'Geen lange wachttijd op of hoge kosten voor het verkrijgen van een netaansluiting. Vind een bestaand stroompunt in de buurt van je project en activeer het direct, vaak binnen enkele dagen, soms zelfs op de werkdag zelf.',
    sec1: {
      eyebrow: 'Wat het oplevert',
      title: 'Voordelen voor aannemers.'
    },
    sec2: {
      eyebrow: 'Vier stappen',
      title: 'Zo gaat het in zijn werk.',
      sub: 'Stroomkaart is gemaakt voor uitvoerders, calculators en projectleiders. Geen losstaand portaal, maar een marktplaats die past bij je bestaande werkwijze.'
    },
    sec3: {
      eyebrow: 'Veelgestelde vragen',
      title: 'Wat aannemers vaak willen weten.'
    },
    feat1: {
      title: 'Volledige ontzorging',
      body: 'Wij regelen het hele proces, van zoeken tot afspraken vastleggen. Jij houdt grip op je project, wij op de stroomvoorziening.'
    },
    feat2: {
      title: 'Direct stroom beschikbaar',
      body: 'Binnen één werkdag een passende voorziening. Geen wachttijden van weken of maanden voor een nieuwe netaansluiting.'
    },
    feat3: {
      title: 'Transparant proces',
      body: 'Van aanvraag tot gebruik volg je elke stap. Heldere prijsopgave vooraf, één aanspreekpunt, één factuur per project.'
    },
    step1: {
      num: 'Stap 01',
      title: 'Zoek & filter',
      body: 'Op locatie, vermogen, type en beschikbaarheids&shy;datum.'
    },
    step2: {
      num: 'Stap 02',
      title: 'Doe een aanvraag',
      body: 'Project, locatie, vermogen, contact. Vijf minuten werk.'
    },
    step3: {
      num: 'Stap 03',
      title: 'Ontvang een prijsopgave',
      body: 'Heldere opgave voor het stroomgebruik, vooraf duidelijk wat je betaalt. Geen verrassingen achteraf.'
    },
    step4: {
      num: 'Stap 04',
      title: 'Aansluiten',
      body: 'Je stroompunt is operationeel op de afgesproken datum.'
    },
    cta: {
      title:       'Klaar om te starten?',
      sub:         'Open de kaart of plan een vrijblijvend kennismakings&shy;gesprek met onze projectcoördinator.',
      btn_map:     'Open de kaart',
      btn_contact: 'Neem contact op',
    },
    faq: {
      q1: 'Wat doet Stroomkaart precies voor mij als aannemer?',
      a1: 'We nemen het hele zoek- en regelproces uit handen. Jij geeft aan waar en wanneer je stroom nodig hebt, met welk vermogen, en wij vinden een passend bestaand stroompunt, leggen contact met de eigenaar en regelen de afspraken. Je krijgt een prijsopgave, je geeft akkoord, en je sluit aan op de afgesproken datum. Geen telefoontjes met netbeheerders, geen uitzoekwerk wie welk punt beheert.',
      q2: 'Hoeveel kost een aansluiting via Stroomkaart?',
      a2: 'Het tarief verschilt per stroompunt. Voor stroompunten die direct gebruikt kunnen worden, zoals een evenementenkast, geldt in veel gevallen enkel een prijs per kWh. Indien aanvullende apparatuur benodigd is, zoals een adapter voor een laadpaal, ontvangt u voor gebruik een prijsopgave ter akkoord.',
      q3: 'Hoe snel kan ik aansluiten?',
      a3: 'Voor stroompunten met status <strong>Beschikbaar</strong> hebben we vaak binnen één werkdag een passend voorstel met prijsopgave. De daadwerkelijke aansluiting is meestal binnen 3 tot 5 werkdagen operationeel, afhankelijk van de eigenaar en eventueel benodigde vergunningen.',
      q4: 'Wat als er geen geschikt stroompunt in mijn buurt staat?',
      a4: 'Dan gaan we voor je op zoek. Je tekent op de kaart het gebied in waar je stroom nodig hebt en geeft je gewenste vermogen en periode op. Wij benaderen actief eigenaren en netbeheerders in dat gebied, ook punten die niet publiek op de kaart staan. Binnen twee weken krijg je een terugkoppeling met opties.',
      q5: 'Is de stroom groen?',
      a5: 'We kunnen niet voor elk stroompunt 100% garanderen dat de stroom groen is, want dat hangt af van het contract van de eigenaar. Voor vragen over een stroompunt kunt je contact opnemen.',
      q6: 'Kan ik later het vermogen aanpassen?',
      a6: 'Ja, mits het stroompunt het toelaat. Aanpassen meld je via je projectcoördinator of in je beheerportaal. We controleren binnen één werkdag of het past en passen je tarief en eindfactuur evenredig aan.',
      q7: 'Wat als er een storing is op de bouwplaats?',
      a7: 'Bij activatie ontvang je een 24/7 storingsnummer.',
    },
    no_point: {
      title: 'Geen geschikt punt gevonden? Wij gaan voor je op zoek.',
      body:  'Teken op de kaart het gebied waar je stroom nodig hebt en geef je gewenste vermogen en periode op. Wij benaderen actief eigenaren en netbeheerders in dat gebied. Binnen twee werkdagen krijg je een voorstel.',
      cta:   'Teken een gebied op de kaart →',
    },
    request_cta: 'Doe direct een aanvraag →',
  },
  voor_evenementen: {
    title: 'Voor markten en evenementen in de openbare ruimte - Stroomkaart',
    eyebrow: 'Voor markten en evenementen in de openbare ruimte',
    h1: 'Stroom voor festivals, markten en sportevenementen.',
    lede: 'Of het nu een festival, een markt of een sportwedstrijd is: vind een geschikt stroompunt op of bij je locatie. Geen aggregaten meer, geen lange kabelroutes - aansluiten op vaste aansluitingen.',
    sec1: {
      eyebrow: 'Wat het oplevert',
      title: 'Voordelen voor evenementenorganisatoren.'
    },
    sec2: {
      eyebrow: 'Vier stappen',
      title: 'Zo gaat het in zijn werk.',
      sub: 'Stroomkaart is gemaakt voor evenementenorganisatoren, festival-coördinatoren en marktmeesters die concrete planning maken. Geen losstaand portaal, maar een marktplaats die past bij je bestaande werkwijze.'
    },
    sec3: {
      eyebrow: 'Veelgestelde vragen',
      title: 'Wat evenementenorganisatoren vaak willen weten.'
    },
    feat1: {
      title: 'Volledige ontzorging',
      body: 'Van het zoeken van een geschikt punt tot afspraken met de gemeente of beheerder. Jij focust op je evenement, wij op de stroomvoorziening.'
    },
    feat2: {
      title: 'Stiller en schoner',
      body: 'Geen lawaaiige diesel-aggregaten, geen brandstoflogistiek. Bestaande netaansluitingen zijn vaak duurzamer en goedkoper.'
    },
    feat3: {
      title: 'Transparant proces',
      body: 'Heldere prijsopgave vooraf, één aanspreekpunt en één factuur per evenement. Geen verrassingen achteraf.'
    },
    step1: {
      num: 'Stap 01',
      title: 'Zoek & filter',
      body: 'Op locatie, vermogen en type evenement. Direct zichtbaar wat past op jouw plein, park of terrein.'
    },
    step2: {
      num: 'Stap 02',
      title: 'Doe een aanvraag',
      body: 'Naam evenement, locatie, datum, vermogen en contact. Vijf minuten werk.'
    },
    step3: {
      num: 'Stap 03',
      title: 'Ontvang een prijsopgave',
      body: 'Heldere opgave voor het stroomgebruik, vooraf duidelijk wat je betaalt. Geen verrassingen achteraf.'
    },
    step4: {
      num: 'Stap 04',
      title: 'Aansluiten',
      body: 'Op de afgesproken datum is je stroomkast klaar voor gebruik, vaak zelf te openen via de Stroomkaart-app.'
    },
    app: {
      eyebrow: 'De Stroomkaart-app',
      title:   'Open de stroomkast met je telefoon.',
      lede:    'Voor evenementen en markten is snelheid op locatie alles. Bij een groeiend aantal stroompunten op de kaart kun je via de Stroomkaart-app de kast direct ontgrendelen, zonder te wachten op een sleutel of een gemeente-medewerker. Je opent de app, selecteert het stroompunt en je hebt stroom.',
      cta:     'Bekijk evenementen-aansluitingen →',
      li1:     '<strong>Zichtbaar op de kaart.</strong> Punten met deze functie hebben de stroomkaart als provider, zodat je vooraf weet welke kasten direct toegankelijk zijn.',
      li2:     '<strong>Veilig en gelogd.</strong> Elke transatie wordt vastgelegd, zodat eigenaren precies weten wie wanneer gebruikmaakt van het punt.',
      li3:     '<strong>Inzicht in verbruik.</strong> Via de app inzicht in de stroomafname. Via een aanvullend verzoek is het mogelijk om real time inzicht in het stroomverbruik te krijgen.',
    },
    no_point: {
      title: 'Geen geschikt punt gevonden? Wij gaan voor je op zoek.',
      body:  'Teken op de kaart het gebied waar je stroom nodig hebt en geef je gewenste vermogen en periode op. Wij benaderen actief eigenaren en netbeheerders in dat gebied. Binnen twee werkdagen krijg je een voorstel.',
      cta:   'Teken een gebied op de kaart →',
    },
    request_cta: 'Doe direct een aanvraag →',
    faq2: {
      q1: 'Wat doet Stroomkaart precies voor mijn evenement?',
      a1: 'We zoeken voor jou een passend bestaand stroompunt op of nabij je locatie, leggen contact met de eigenaar (vaak de gemeente) en regelen de afspraken. Je krijgt een prijsopgave, geeft akkoord en op de afgesproken datum is de kast klaar voor gebruik. Bij steeds meer punten kun je de kast zelf openen via onze app.',
      q2: 'Wat kost het om gebruik te maken van een evenementen-aansluiting?',
      a2: 'Je betaalt vaak een eenmalige administratieve fee per aanvraag plus het werkelijke stroomverbruik tegen een transparant tarief per kWh. Voor markten en kleinere evenementen valt dat vaak fors goedkoper uit dan het huren van aggregaten.',
      q3: 'Hoe weet ik of een stroomkast via de app te openen is?',
      a3: 'Op de kaart staat bij deze punten aangegeven dat Stroomkaart de provider is.',
      q4: 'Wat als er geen geschikt punt op mijn evenementenlocatie staat?',
      a4: 'Teken op de kaart het gebied waar je evenement plaatsvindt en geef je gewenste vermogen en data op. Wij benaderen actief eigenaren en de gemeente in dat gebied, ook punten die niet publiek op de kaart staan. Binnen twee werkdagen krijg je een terugkoppeling met opties.',
      q5: 'Hoe ver van tevoren moet ik aanvragen?',
      a5: 'Een aanvraag dient tenminste 5 werkdagen van te voren worden ingediend.',
      q6: 'Is de stroom groen?',
      a6: 'We kunnen niet voor elk stroompunt 100% garanderen dat de stroom groen is, want dat hangt af van het contract van de eigenaar.',
    },
    cta_strip: {
      title:     'Heeft uw evenement een aansluiting nodig?',
      sub:       'Doe een aanvraag of bekijk eerst welke punten er bij uw locatie staan.',
      primary:   'Direct aanvragen',
      secondary: 'Even sparren',
    },
    cta: {
      btn_contact: 'Neem contact op',
      btn_map: 'Open de kaart',
      sub: 'Open de kaart of plan een vrijblijvend kennismakings&shy;gesprek met onze projectcoördinator.',
      title: 'Klaar om te starten?',
    },
  },
  voor_film: {
    title: 'Voor filmproducties - Stroomkaart',
    eyebrow: 'Voor filmproducties',
    h1: 'Productiestroom op locatie zonder ronkende generatoren.',
    lede: 'Camera, geluid, belichting, catering - filmproducties hebben veel stroom nodig. Stroomkaart helpt je vinden van vaste stroompunten in de buurt van je locatie zodat je niet hoeft te leunen op luidruchtige aggregaten.',
    sec1: {
      eyebrow: 'Wat het oplevert',
      title: 'Voordelen voor filmorganisaties.'
    },
    sec2: {
      eyebrow: 'Vier stappen',
      title: 'Zo gaat het in zijn werk.',
      sub: 'Stroomkaart is gemaakt voor producenten, locatiescouts en gaffer-teams die concrete planning maken. Geen losstaand portaal, maar een marktplaats die past bij je bestaande werkwijze, of het nu om een driedaagse speelfilm-set, een commercial of een documentaire-shoot gaat.'
    },
    sec3: {
      eyebrow: 'Veelgestelde vragen',
      title: 'Wat filmorganisaties vaak willen weten.'
    },
    feat1: {
      title: 'Geen geluidsoverlast',
      body: 'Stille netaansluiting in plaats van diesel-aggregaten. Cruciaal in woonwijken, in de stad of bij geluidsopnames op locatie.'
    },
    feat2: {
      title: 'Lagere productiekosten',
      body: 'Geen huur van aggregaten, geen brandstof, geen logistiek op locatie. Voor meerdaagse producties scheelt dat honderden euro\'s per dag.'
    },
    feat3: {
      title: 'Transparant proces',
      body: 'Vooraf duidelijke prijsopgave, één aanspreekpunt en één factuur per shoot. Past in duurzaamheidsrapportage van opdrachtgevers.'
    },
    step1: {
      num: 'Stap 01',
      title: 'Zoek & filter',
      body: 'Op locatie, vermogen en periode. Filter op stille netaansluitingen in de buurt van je shoot-locatie.'
    },
    step2: {
      num: 'Stap 02',
      title: 'Doe een aanvraag',
      body: 'Productie, locatie, opname-data, vermogen en contact. Vijf minuten werk.'
    },
    step3: {
      num: 'Stap 03',
      title: 'Ontvang een prijsopgave',
      body: 'Heldere opgave voor het stroomgebruik, vooraf duidelijk wat je betaalt. Vergelijk eenvoudig met de kosten van een aggregaat.'
    },
    step4: {
      num: 'Stap 04',
      title: 'Aansluiten',
      body: 'Op de eerste opnamedag is de stroomvoorziening operationeel. Geen logistiek, geen brandstof, gewoon stroom.'
    },
    cta: {
      title:       'Volgende productie op locatie?',
      sub:         'Bekijk welke aansluitingen er bij je shoot-locatie staan, of vraag direct een aansluiting aan.',
      btn_map:     'Open de kaart',
      btn_request: 'Direct aanvragen',
    },
    faq: {
      q1: 'Wat doet Stroomkaart precies voor mijn productie?',
      a1: 'We zoeken voor jouw shoot-locatie een passend bestaand stroompunt op, leggen contact met de eigenaar en regelen de afspraken. Je krijgt een prijsopgave, geeft akkoord en op de eerste opnamedag is de aansluiting klaar voor gebruik. Geen aggregaten, geen brandstoflogistiek, geen klachten van omwonenden over het lawaai.',
      q2: 'Hoeveel kost een aansluiting via Stroomkaart?',
      a2: 'Je betaalt in veel gevallen een eenmalige administratieve fee per aanvraag plus het werkelijke verbruik tegen een transparant tarief per kWh. Voor meerdaagse producties is dit vrijwel altijd goedkoper dan het huren en exploiteren van aggregaten op locatie.',
      q3: 'Geschikt voor zware lichtparken en grote sets?',
      a3: 'Ja. We hebben aansluitingen vari\\u00ebrend van lichte 16A-punten tot 250-400 kVA voor grote producties. Filter op de kaart op het vermogen dat je nodig hebt.',
      q4: 'Wat als er geen geschikt punt op mijn shoot-locatie staat?',
      a4: 'Teken op de kaart het gebied waar je opneemt en geef je gewenste vermogen en data op. Wij benaderen actief eigenaren en netbeheerders in dat gebied, ook punten die niet publiek op de kaart staan. Binnen twee werkdagen krijg je een terugkoppeling.',
      q5: 'Is de stroom groen?',
      a5: 'We kunnen niet voor elk stroompunt 100% garanderen dat de stroom groen is, want dat hangt af van het contract van de eigenaar.',
      q6: 'Hoe ver vooraf moet ik aanvragen?',
      a6: 'Voor het gebruik van een stroompunt op de kaart dien je tenminste 5 werkdagen van te voren een aanvraag in te dienen.',
    },
    no_point: {
      title: 'Geen geschikt punt op je shoot-locatie? Wij gaan voor je op zoek.',
      body:  'Teken op de kaart het gebied waar je opnames plaatsvinden en geef je gewenste vermogen en data op. Wij benaderen actief eigenaren en netbeheerders in dat gebied. Binnen twee werkdagen krijg je een terugkoppeling met opties.',
      cta:   'Teken een gebied op de kaart \\u2192',
    },
    request_cta: 'Doe direct een aanvraag \\u2192',
  },
  voor_gemeenten: {
    title: 'Voor overheidsorganisaties - Stroomkaart',
    eyebrow: 'Voor overheidsorganisaties',
    h1: 'Maak overcapaciteit zichtbaar en benut wat er al ligt.',
    lede: 'Bestaande stroomaansluitingen in eigendom van overheden bieden vaak veel overcapaciteit, denk aan een evenementenaansluitingen of gemalen. Door ze via Stroomkaart aan te bieden, ontlast u de lokale netbeheerder en worden stroomvragers in de openbare ruimte gestimuleerd om niet met aggregaten te werken. Aanmelden is gratis, en met additionele meetdiensten worden uw aansluitingen net zo eenvoudig inzetbaar als een openbare laadpaal.',
    sec1: {
      eyebrow: 'Wat het oplevert',
      title: 'Voordelen voor overheidsorganisaties.'
    },
    sec2: {
      eyebrow: 'Twee aanmeldroutes',
      title: 'Twee manieren om uw stroompunten aan te melden.',
      sub: 'Of u nu klein wilt beginnen met een uitdraai van uw bestaande aansluitingen-bestand, of direct een geautomatiseerde koppeling wilt opzetten.'
    },
    sec3: {
      eyebrow: 'In 4 stappen live',
      title: 'Hoe een stroompunt op de kaart komt.',
      sub: 'De route van eerste contact tot live-op-de-kaart kan binnen één tot twee weken doorlopen worden. Voor uitgebreidere koppelingen plannen we een korte technische sessie in.'
    },
    feat1: {
      title: 'Aanmelden is gratis',
      body: 'Geen aansluitkosten, geen platformkosten, geen abonnement. U meldt uw stroompunten kosteloos aan en bepaalt zelf wat publiek zichtbaar is.'
    },
    feat2: {
      title: 'Slimme optimalisatie',
      body: 'Met additionele meetdiensten worden uw aansluitingen net zo eenvoudig inzetbaar als een openbare laadpaal: aanvragen, autoriseren en gebruik gaan automatisch.'
    },
    feat3: {
      title: 'Regie en inzicht',
      body: 'U bepaalt zelf welke punten beschikbaar komen, voor wie en onder welke voorwaarden. Realtime dashboard met gebruik en bezetting per punt.'
    },
    opt1: {
      num: 'Optie 01',
      title: 'Eenmalige upload',
      effort: 'Inspanning: medium· Direct te starten',
      body: 'Heeft u uw aansluitingen al in een spreadsheet of asset-systeem staan? Lever een uitdraai aan van uw eigen aansluitingenbestand en wij verwerken dit voor u. Binnen enkele werkdagen staan uw stroompunten op de kaart.',
      li1: 'Geschikt voor organisaties zonder real-time meetdata.',
      li2: 'Updates verlopen periodiek (handmatig of via een nieuwe upload)',
      li3: 'Beschikbaarheid wijzigt u zelf in uw beheerportaal',
      li4: 'Goede manier om eerst ervaring op te doen',
      cta: 'Direct aanmelden'
    },
    opt2: {
      num: 'Optie 02',
      title: 'Interactieve Stroomkaart van NRG Group',
      effort: 'Inspanning laag · Realtime & geautomatiseerd',
      body: 'Voor wie volledig inzicht wil in de eigen aansluitingen: koppel uw grootverbruikaansluitingen via API en uw kleinverbruikaansluitingen via ODA aan een digitale kaartlaag. Per stroompunt ziet u realtime de beschikbare capaciteit, zodat u ook intern weet waar overcapaciteit benut kan worden.',
      li1: 'Beantwoordt vragen als: welke aansluitingen hebben structurele overcapaciteit, en waar liggen de witte vlekken in het netwerk?',
      li2: 'Inzicht in overcapaciteit per uur, dag en seizoen',
      li3: 'Automatische actualisatie via ODA-koppeling (kleinverbruik) en API-koppeling (grootverbruik)',
      li4: 'Inrichting op maat: standalone NRG-webomgeving, ontsloten binnen bestaande GIS (bijv. ArcGIS), of onderliggende data via API',
      li5: 'Voorbeeldcase Gemeente Leiden: laadvoorziening op een gemeentelijk gemaal - overcapaciteit voor laden van materieel, gemaal altijd voorrang. Goedkoper dan mobiele stroombronnen en lagere kWh-prijs dan diesel.',
      cta: 'Meer info op nrggroup.nl'
    },
    step1: {
      num: 'Stap 01',
      title: 'Aansluitingen aanleveren',
      body: 'Via een uitdraai van uw bestaande aansluitingen&shy;bestand, of via slimme meters van de NRG-meetdienst.'
    },
    step2: {
      num: 'Stap 02',
      title: 'Validatie',
      body: 'Wij verwerken de data, valideren per record en stemmen af op uw situatie.'
    },
    step3: {
      num: 'Stap 03',
      title: 'Voorwaarden instellen',
      body: 'Per punt bepaalt u zichtbaarheid, doelgroepen en eventuele prijsstelling. Volledige regie blijft bij u.'
    },
    step4: {
      num: 'Stap 04',
      title: 'Live op de kaart',
      body: 'Punten zijn zichtbaar voor aanvragers in heel Nederland. Aanvragen komen binnen in uw beheerportaal.'
    },
    dashboard_callout:   '<strong>Eén dashboard voor alle aansluitingen.</strong> Met de Interactieve Stroomkaart ziet u niet alleen welke punten beschikbaar zijn voor anderen via Stroomkaart, maar ook welke aansluitingen binnen uw eigen organisatie overcapaciteit hebben. Zo kunt u capaciteit gericht inzetten voor projecten zoals laadinfrastructuur, ZE-materieel of evenementen - voordat u nieuwe aansluitingen aanvraagt.',
    partners_eyebrow:    'Een greep uit onze partners',
    cta_strip: {
      title:     'Klaar om uw eerste stroompunten aan te melden?',
      sub:       'Twee aansluit&shy;methoden - eenmalige Excel-upload of de NRG-meetdienst. U bepaalt zelf wat past.',
      primary:   'Direct aanmelden',
      secondary: 'Plan eerst een gesprek',
    },
  },
  voor_bedrijven: {
    title: 'Voor bedrijven - Stroomkaart',
    eyebrow: 'Voor bedrijven',
    h1: 'Maak uw stroompunten te gelde - en beschikbaar voor anderen.',
    lede: 'Vastgoedbeheerders, ketenpartners en industriële complexen hebben vaak meer stroomcapaciteit dan ze dagelijks gebruiken. Stroomkaart helpt deze overcapaciteit te ontsluiten voor projecten die tijdelijk stroom nodig hebben - met u als beheerder van de voorwaarden.',
    sec1: {
      eyebrow: 'Wie meldt aan',
      title: 'Drie typische profielen.'
    },
    sec2: {
      eyebrow: 'Twee aanmeldroutes',
      title: 'Twee manieren om uw aansluitingen aan te melden.',
      sub: 'Of u nu klein wilt beginnen met een uitdraai van uw bestaande aansluitingen-bestand, of direct een geautomatiseerde koppeling met uw netaansluiting(en) wilt opzetten.'
    },
    feat1: {
      title: 'Vastgoedbeheerders',
      body: 'Bedrijfsverzamelgebouwen, kantoorpanden en logistieke complexen met aansluitingen die buiten kantooruren vrij zijn. Ideaal voor kleine bouwwerkzaamheden of evenementen.'
    },
    feat2: {
      title: 'Ketenpartners & leveranciers',
      body: 'Aannemers, installateurs en bouwleveranciers die zelf bouwkasten beheren. Bied uw vrije capaciteit aan in periodes tussen projecten in.'
    },
    feat3: {
      title: 'Industrie & logistiek',
      body: 'Industriële complexen, distributiecentra en haventerreinen met zware aansluitingen die in nachten of weekends ongebruikt zijn. Gecontroleerd openstellen levert direct rendement op.'
    },
    opt1: {
      num: 'Optie 01',
      title: 'Eenmalige upload',
      effort: 'Inspanning: medium - Direct te starten',
      body: 'Heeft u uw aansluitingen al in een spreadsheet of asset-systeem staan? Lever een uitdraai aan van uw eigen aansluitingenbestand en wij verwerken dit voor u. Binnen enkele werkdagen staan uw aansluitingen op de kaart.',
      li1: 'Geschikt voor bedrijven zonder real-time meetdata',
      li2: 'Updates verlopen periodiek (handmatig of via een nieuwe upload)',
      li3: 'Beschikbaarheid wordt door Stroomkaart bijgehouden',
      li4: 'Goede manier om eerst ervaring op te doen',
      cta: 'Direct aanmelden'
    },
    opt2: {
      num: 'Optie 02',
      title: 'Automatische ODA- of API-koppeling',
      effort: 'Inspanning:  laag - Geautomatiseerd',
      body: 'Voor bedrijven die continu actuele data willen tonen: NRG Group koppelt uw kleinverbruikaansluitingen via ODA en uw grootverbruikmeter via een rechtstreekse API-koppeling. Beschikbare capaciteit en status worden automatisch en realtime op de kaart weergegeven, zonder dat u eigen monitoring of IT-infrastructuur hoeft op te zetten.',
      li1: 'Realtime status op de kaart - beheer en aanvragen worden door het Stroomkaart-team afgehandeld.',
      li2: 'ODA-koppeling voor kleinverbruikaansluitingen, API-koppeling voor grootverbruikmeters',
      li3: 'Inzicht in overcapaciteit per uur, dag en seizoen - handig voor het slim aanbieden van vrije capaciteit',
      li4: 'Onderdeel van de digitale stroomkaart-dienst van NRG Group',
      cta: 'Meer info op nrggroup.nl'
    },
    callout: '<strong>U bepaalt zelf de voorwaarden - wij regelen het beheer.</strong> Per aansluiting kiest u of die publiek zichtbaar is op de kaart, of alleen binnen uw eigen netwerk benaderbaar. Het Stroomkaart-team borgt de afhandeling van binnenkomende aanvragen, op basis van vooraf met u afgestemde criteria (project, capaciteit, gewenste periode, certificeringen, verzekeringseisen).',
    cta: {
      title:     'Klaar om uw onbenutte capaciteit te ontsluiten?',
      sub:       'Twee aansluit&shy;methoden, volledige controle over voorwaarden en zichtbaarheid. Het Stroomkaart-team handelt aanvragen voor u af.',
      primary:   'Direct aanmelden',
      secondary: 'Contact',
    },
  },
  voor_laadpalen: {
    title: 'Voor gemeenten & laadpaal-operators - Stroomkaart',
    eyebrow: 'Voor gemeenten & laadpaal-operators',
    h1: 'Maak laadpalen vindbaar voor bouw, evenementen en andere stroomaanvragers.',
    lede: 'Naast EV-rijders kunnen ook bouwbedrijven, evenementen-organisatoren en filmsets gebruik maken van openbare laadpalen. Stroomkaart helpt de laadpunten zichtbaar te maken en veilig in te zetten voor deze nieuwe doelgroepen.',
    sec1: {
      eyebrow: 'Wat het oplevert',
      title: 'Voordelen voor gebruikers, gemeenten en laadpaal operators.'
    },
    sec2: {
      eyebrow: 'Veilig en technisch toelaatbaar',
      title: 'Hoe het werkt:<br>Bouwlaadpas en laadpaaladapter.',
      intro: 'Openbare laadpalen zijn ontworpen om elektrische voertuigen te laden. Voor gebruik door andere doelgroepen moet je rekening houden met een paar technische uitgangspunten. Deze sectie volgt de richtlijnen uit de NKL-handreiking Veilig gebruik van openbare laadpalen voor de bouw.'
    },
    sec3: {
      eyebrow: 'Realistische scope',
      title: 'Wat past wel en wat niet op een laadpaal.',
      sub: 'Een openbare laadpaal levert typisch 11 kW per socket.'
    },
    sec4: {
      eyebrow: 'Vier stappen',
      title: 'Zo gaat het in zijn werk.',
      sub: 'Het gebruik van een openbare laadpaal voor de bouw vraagt afstemming tussen drie partijen: de aannemer, de gemeente (of opdrachtgever) en de CPO (de exploitant van de laadpaal). Stroomkaart regelt dat traject voor je.'
    },
    sec5: {
      eyebrow: 'Veelgestelde vragen',
      title: 'Wat aannemers en gemeenten vaak willen weten.'
    },
    feat1: {
      title: 'Emissieloos',
      body: 'Geen dieselaggregaten nodig voor kleinere en stilstaande apparaten. Direct stroom uit het bestaande net, dichtbij waar je het nodig hebt.'
    },
    feat2: {
      title: 'Stiller en schoner voor omwonenden',
      body: 'Minder geluids- en stankoverlast in stedelijk gebied. Voorkomt klachten en past in eisen voor emissieloze bouwplaatsen.'
    },
    feat3: {
      title: 'Snel inzetbaar',
      body: 'De laadpaal staat er al. Met een bouwlaadpas en de juiste adapter kun je vaak binnen één werkdag plug-and-play aan de slag.'
    },
    step1: {
      num: 'Stap 01',
      title: 'Zoek & controleer',
      body: 'Filter op type "Laadpaal" op de kaart en controleer welke palen rond je locatie staan.'
    },
    step2: {
      num: 'Stap 02',
      title: 'Maak afspraken',
      body: 'Wij regelen de toestemming bij gemeente en CPO.'
    },
    step3: {
      num: 'Stap 03',
      title: 'Bouwlaadpas & adapter',
      body: 'Je ontvangt een bouwlaadpas en, indien nodig, een veilige adapter voor materieel zonder type 2-stekker.'
    },
    step4: {
      num: 'Stap 04',
      title: 'Aansluiten en starten',
      body: 'Pas voor de paal houden, kabel inpluggen, klaar. Eén factuur per project.'
    },
    cta: {
      title: 'Nieuwsgierig of dit voor jouw project past?',
      sub:   'Open de kaart, of plan vijf minuten met onze projectcoördinator om het door te rekenen.',
      cta1:  'Bekijk laadpalen',
      cta2:  'Plan een gesprek',
    },
    faq: {
      q1: 'Mag ik überhaupt een openbare laadpaal voor bouwwerk gebruiken?',
      a1: 'Ja, mits met toestemming van de eigenaar van de paal (de CPO) en in afstemming met de gemeente. Stroomkaart regelt deze afstemming voor je per project.',
      q2: 'Wat is een bouwlaadpas en heb ik die echt nodig?',
      a2: 'Ja, de bouwlaadpas borgt de registratie van dit type gebruik.',
      q3: 'Wanneer heb ik een adapter nodig?',
      a3: 'Alleen als je materieel geen type 2-stekker volgens het mode 3-protocol heeft. Belangrijk: gebruik geen willekeurige adapter. Op de markt zijn adapters die niet aan de veiligheidsrichtlijnen voldoen en gevaarlijke situaties kunnen veroorzaken. We leveren een adapter mee die voldoet aan de geldende richtlijnen.',
      q4: 'Wat als de laadpaal verder van de bouwplaats afstaat?',
      a4: 'Het gebruik van laadpalen die wat verder van de bouwplaats afstaan is maatwerk, neem hiervoor contact op om de mogelijkheden te onderzoeken.',
      q5: 'Welk vermogen kan ik verwachten?',
      a5: 'Openbare laadpalen leveren veelal tot 11 kW per socket. Dat is voldoende voor kleinere en stilstaande apparaten - bouwketen, gereedschap, lichte machines, opladen van elektrische bestelbussen.',
      q6: 'Wat als de paal stuk gaat door verkeerd gebruik?',
      a6: 'De gebruiker is verantwoordelijk voor veilig aan- en afkoppelen en voor het afschermen van de paal tijdens gebruik. Bij schade worden eventuele herstel- of vervangingskosten in rekening gebracht bij de gebruiker.',
      q7: 'Worden EV-rijders niet gehinderd?',
      a7: 'In veel gevallen niet aangezien de laadpaal voor regulier ev niet bereikbaar is als de straat is afgesloten.',
    },
    no_point: {
      title: 'Geen laadpaal in de buurt? Wij denken mee.',
      body:  'Soms staan er nog geen of niet voldoende laadpalen op of bij je bouwlocatie. De gemeente kan overwegen om laadpalen te plaatsen op een plek waar ná de bouw EV-rijders zullen willen laden. Dat soort voorstellen begeleiden we vanuit Stroomkaart.',
      cta:   'Plan een verkenning →',
    },
    request_cta:   'Doe direct een aanvraag →',
    situation1: {
      label: 'Situatie 1 - Materieel met type 2-stekker',
      title: 'Direct aansluiten',
      body:  'Materieel dat zelf voorzien is van een <strong>type 2-stekker</strong> volgens het <strong>mode 3-protocol</strong> (de standaard voor openbaar laden) kan rechtstreeks worden aangesloten op een openbare laadpaal, net als een elektrische auto. Het laadstation en het apparaat communiceren onderling over de juiste laadstroom.',
    },
    situation2: {
      label: 'Situatie 2 - Materieel zonder type 2-stekker',
      title: 'Aansluiten met een veilige laadpaaladapter',
      body:  'Voor materieel dat geen type 2-stekker heeft is een adapter nodig. Belangrijk: niet alle adapters op de markt voldoen aan de veiligheidseisen. Gebruik altijd een adapter die voldoet aan de NKL-eisenset om gevaarlijke situaties en schade aan de laadinfrastructuur te voorkomen.',
    },
    adapter_cta:   'Vraag de NRG-adapter aan →',
    bouwlaadpas:   '<strong>De bouwlaadpas.</strong> Met een bouwlaadpas activeer je de laadpaal en kunnen wij in overleg met de CPO regelingen uitschakelen die continue stroomafname hinderen, zoals slim laden.',
    bouwlaadpas_cta: 'Bouwlaadpas aanvragen →',
    fits: {
      label: 'Past op een laadpaal',
      l1: 'Bouwketen, schaftruimte, bouwverlichting',
      l2: 'Handgereedschap en kleinere stilstaande apparaten',
      l3: 'Elektrische bestelbussen en bouwwagens opladen',
      l4: 'Klein elektrisch materieel (mini-graver, steigerlift, elektrische pomp)',
      l5: "Tijdelijke beveiligingscamera's en sensoren",
    },
    notfits: {
      label: 'Vraag of ga op zoek naar een stroompunt met meer capaciteit',
      l1: 'Materieelstukken, zoals torenkranen, met een hoge aanloopstroom',
      l2: 'Doorlopende stroomvraag, vanuit verwarming of grote pompen, met een constante vermogensvraag van meer dan 32A.',
      l3: 'Materieel met een accucapaciteit van meer dan 200 kWh.',
    },
    notsure:       '<strong>Niet zeker?</strong> Neem contact en we werken gezamenlijk de vermogensvraag uit.',
    feat4: {
      title: 'Extra inkomsten voor operators',
      body:  'Verdien aan laadinfrastructuur die tijdelijk niet door EV-rijders wordt gebruikt. Stille uren krijgen alsnog rendement zonder extra investering.',
    },
    nkl_link:      'Lees de volledige NKL-handreiking →',
    nkl_url:       'https://www.nklnederland.nl',
    flyer_cta:     'Download de flyer (PDF)',
    flyer_url:     'assets/flyers/adapter-brochure-nl.pdf',
  },
};

export const en = {
  voor_bouwers: {
    title: 'For contractors - Stroomkaart',
    eyebrow: 'For contractors',
    h1: 'Temporary construction power without waiting times.',
    lede: 'No long waiting times or high costs for a temporary grid connection. Find an existing connection near your project and activate it directly - often within days, sometimes even on the working day itself.',
    sec1: {
      eyebrow: 'What it delivers',
      title: 'Benefits for contractors.'
    },
    sec2: {
      eyebrow: 'Four steps',
      title: 'How it works.',
      sub: 'NRGmaps is built for site managers, estimators and project leaders. Not a separate portal, but a marketplace that fits your existing workflow.'
    },
    sec3: {
      eyebrow: 'Frequently asked questions',
      title: 'What contractors often want to know.'
    },
    feat1: {
      title: 'Full unburdening',
      body: 'We arrange the entire process, from search to confirmed agreements. You stay focused on your project, we focus on the power supply.'
    },
    feat2: {
      title: 'Power available right away',
      body: 'A suitable supply within one business day. No waits of weeks or months for a new grid connection.'
    },
    feat3: {
      title: 'Transparent process',
      body: 'From request to use you follow every step. Clear quotes upfront, one point of contact, one invoice. No surprises afterwards.'
    },
    step1: {
      num: 'Step 01',
      title: 'Search & filter',
      body: 'By location, capacity, type and availability date.'
    },
    step2: {
      num: 'Step 02',
      title: 'Submit a request',
      body: 'Project, location, capacity, contact. Five minutes of work.'
    },
    step3: {
      num: 'Step 03',
      title: 'Receive a quote',
      body: 'Clear quote for power use, transparent on what you pay upfront. No hidden costs.'
    },
    step4: {
      num: 'Step 04',
      title: 'Connect',
      body: 'Your connection is operational on the agreed date.'
    },
    cta: {
      title:       'Ready to start?',
      sub:         'Open the map or schedule a no-obligation introductory call with our project coordinator.',
      btn_map:     'Open the map',
      btn_contact: 'Get in touch',
    },
    faq: {
      q1: 'What exactly does nrgmaps do for me as a contractor?',
      a1: 'We take the entire search and arrangement process off your hands. You indicate where and when you need power and at what capacity, and we find a suitable existing connection, contact the owner and arrange the agreements. You receive a quote, you give approval, and you connect on the agreed date. No phone calls with grid operators, no figuring out who manages which point.',
      q2: 'How much does a connection via nrgmaps cost?',
      a2: 'The rate differs per connection. For power points that can be used directly, such as an event connection, in many cases only a price per kWh applies. If additional equipment is needed, such as an adapter for a charging station, you receive a quote for approval before use.',
      q3: 'How quickly can I connect?',
      a3: 'For power points with status <strong>Available</strong> we often have a suitable proposal with a quote within one working day. The actual connection is usually operational within 3 to 5 working days, depending on the owner and any required permits.',
      q4: 'What if there is no suitable power point in my area?',
      a4: 'Then we go searching for you. You draw on the map the area where you need power and indicate the desired capacity and period. We actively contact owners and grid operators in that area, including points that are not publicly listed on the map. Within two weeks you receive feedback with options.',
      q5: 'Is the power green?',
      a5: "We cannot guarantee 100% for every power point that the power is green, as that depends on the owner\u2019s contract. For questions about a power point, please contact us.",
      q6: 'Can I adjust the capacity later?',
      a6: 'Yes, if possible within the capacity of the grid connections. You report adjustments via your project coordinator or in your admin portal. We check within one working day whether it fits and adjust your rate and final invoice accordingly.',
      q7: 'What if there is an outage on the construction site?',
      a7: 'On activation you receive a 24/7 contact number.',
    },
    no_point: {
      title: 'No suitable point found? We will search for you.',
      body:  'Draw on the map the area where you need power and indicate the desired capacity and period. We actively contact owners and grid operators in that area. Within two working days you receive a proposal.',
      cta:   'Draw an area on the map',
    },
    request_cta: 'Submit a request directly',
  },
  voor_evenementen: {
    title: 'For markets and events in public space - Stroomkaart',
    eyebrow: 'For markets and events in public space',
    h1: 'Power for festivals, markets and sports events.',
    lede: 'Whether it is a festival, a market or a sports match: find a suitable power point at or near your venue. No more generators, no more long cable routes - connect to fixed event power points.',
    sec1: {
      eyebrow: 'What it delivers',
      title: 'Benefits for event organisers.'
    },
    sec2: {
      eyebrow: 'Four steps',
      title: 'How it works.',
      sub: 'NRGmaps is built for event organisers, festival coordinators and city event teams who need clarity weeks in advance. Not a separate portal, but a marketplace that fits your existing workflow.'
    },
    sec3: {
      eyebrow: 'Frequently asked questions',
      title: 'What event organisers often want to know.'
    },
    feat1: {
      title: 'Full unburdening',
      body: 'From finding a suitable point to arranging things with the municipality or owner. One central contact for the entire power supply.'
    },
    feat2: {
      title: 'Quieter and cleaner',
      body: 'No noisy diesel generators, no fuel logistics. Existing grid connections deliver power directly to your event - no roar, no emissions.'
    },
    feat3: {
      title: 'Transparent process',
      body: 'Clear quote upfront, one point of contact, one invoice per event. No surprises afterwards.'
    },
    step1: {
      num: 'Step 01',
      title: 'Search & filter',
      body: 'By location, capacity and type of event. See instantly what fits at your square, park or venue.'
    },
    step2: {
      num: 'Step 02',
      title: 'Submit a request',
      body: 'Event name, location, date, capacity and contact. Five minutes of work.'
    },
    step3: {
      num: 'Step 03',
      title: 'Receive a quote',
      body: 'Clear quote for power use, transparent on what you pay upfront. No hidden costs.'
    },
    step4: {
      num: 'Step 04',
      title: 'Connect',
      body: 'On the agreed date your power cabinet is ready for use, often self-operable with the supplied key or via the Stroomkaart app.'
    },
    app: {
      eyebrow: 'The Stroomkaart app',
      title:   'Open the power cabinet with your phone.',
      lede:    'For events and markets, speed on location is everything. With a growing number of power points on the map, you can unlock the cabinet directly via the Stroomkaart app, without waiting for a key or a municipal staff member. You open the app, select the power point and you have power.',
      cta:     'View event connections →',
      li1:     '<strong>Visible on the map.</strong> Points with this function have stroomkaart as their provider, so you know in advance which cabinets are directly accessible.',
      li2:     '<strong>Safe and logged.</strong> Every transaction is recorded, so owners know exactly who uses the point and when.',
      li3:     '<strong>Insight into consumption.</strong> Get insight into power usage via the app. With an additional request, real-time insight into power consumption is also possible.',
    },
    no_point: {
      title: 'No suitable point at your location? We will look for you.',
      body:  'Draw the area where your event takes place on the map and indicate your required capacity and dates. We actively approach owners and the municipality in that area. Within two working days you will receive feedback with options.',
      cta:   'Draw an area on the map',
    },
    request_cta: 'Submit a request directly',
    faq2: {
      q1: 'What does Stroomkaart actually do for my event?',
      a1: 'We find a suitable existing power point at or near your venue, make contact with the owner (often the municipality) and set up the arrangements. You get a quote, you approve, and on the agreed date the cabinet is ready for use. At a growing number of points you can open the cabinet yourself via our app.',
      q2: 'What does it cost to use an event connection?',
      a2: 'You usually pay a one-off administrative fee per request plus the actual consumption at a transparent kWh rate. For markets and smaller events this often works out substantially cheaper than renting generators.',
      q3: 'How do I know whether a cabinet can be opened via the app?',
      a3: 'On the map, points where this is possible are flagged with Stroomkaart as the provider.',
      q4: 'What if there is no suitable point at my event venue?',
      a4: 'Draw the area where your event takes place on the map and provide your desired capacity and dates. We actively approach owners and the municipality in that area, including points not publicly on the map. Within two business days you receive a response with options.',
      q5: 'How far in advance should I request?',
      a5: 'A request must be submitted at least 5 business days in advance.',
      q6: 'Is the power green?',
      a6: "We cannot 100% guarantee that the power is green for every point, because that depends on the owner's contract.",
    },
    cta_strip: {
      title:     'Does your event need a power connection?',
      sub:       'Submit a request or first see which points are at your venue.',
      primary:   'Request directly',
      secondary: 'Have a chat',
    },
    cta: {
      btn_contact: '',
      btn_map: '',
      sub: '',
      title: '',
    },
  },
  voor_film: {
    title: 'For film productions - Stroomkaart',
    eyebrow: 'For film productions',
    h1: 'On-location production power without roaring generators.',
    lede: 'Camera, sound, lighting, catering - film productions need a lot of power. nrgmaps helps you find fixed grid connections near your location so you do not have to rely on noisy generators.',
    sec1: {
      eyebrow: 'What it delivers',
      title: 'Benefits for film productions.'
    },
    sec2: {
      eyebrow: 'Four steps',
      title: 'How it works.',
      sub: 'Stroomkaart is built for producers, location scouts and gaffer teams who need certainty before the shoot. Not a separate portal, but a marketplace that fits your existing workflow.'
    },
    sec3: {
      eyebrow: 'Frequently asked questions',
      title: 'What film productions often want to know.'
    },
    feat1: {
      title: 'No noise pollution',
      body: 'Silent grid connection instead of diesel generators. Crucial in residential areas, in nature reserves and during night shoots where every dB counts.'
    },
    feat2: {
      title: 'Lower production costs',
      body: 'No generator hire, no fuel, no on-site logistics. For multi-day shoots: substantially cheaper than a generator from minute one.'
    },
    feat3: {
      title: 'Transparent process',
      body: 'Clear quote upfront, one point of contact, one invoice per shoot. Fits naturally with the production budget and accounts for the producer.'
    },
    step1: {
      num: 'Step 01',
      title: 'Search & filter',
      body: 'By location, capacity and type. Check during scouting whether a fixed power supply is available before the location is confirmed.'
    },
    step2: {
      num: 'Step 02',
      title: 'Submit a request',
      body: 'Production, location, dates, capacity and contact. Five minutes of work.'
    },
    step3: {
      num: 'Step 03',
      title: 'Receive a quote',
      body: 'Clear quote for power use, including key handover or app access. No hidden costs.'
    },
    step4: {
      num: 'Step 04',
      title: 'Connect',
      body: 'On the agreed date your power cabinet is ready - often self-operable, no need to wait for a technician.'
    },
    cta: {
      title:       'Next production on location?',
      sub:         'See which connections are at your shoot location, or submit a request directly.',
      btn_map:     'Open the map',
      btn_request: 'Request now',
    },
    faq: {
      q1: 'What does Stroomkaart do exactly for my production?',
      a1: 'We find a suitable existing power point for your shoot location, contact the owner and arrange the agreements. You receive a quote, give your approval, and on the first shooting day the connection is ready to use. No generators, no fuel logistics, no complaints from neighbours about noise.',
      q2: 'How much does a connection via Stroomkaart cost?',
      a2: 'In most cases you pay a one-off administrative fee per request plus the actual consumption at a transparent rate per kWh. For multi-day productions this is almost always cheaper than renting and operating generators on location.',
      q3: 'Suitable for heavy lighting rigs and large sets?',
      a3: 'Yes. We have connections ranging from light 16A points up to 250-400 kVA for large productions. Filter on the map by the capacity you need.',
      q4: 'What if there is no suitable point at my shoot location?',
      a4: 'Draw on the map the area where you are filming and indicate your required capacity and dates. We actively approach owners and grid operators in that area, including points that are not publicly listed. Within two business days you receive feedback.',
      q5: 'Is the power green?',
      a5: "We cannot guarantee 100% green power for every point, as that depends on the owner\u2019s contract.",
      q6: 'How far in advance do I need to request?',
      a6: 'To use a power point on the map you must submit a request at least 5 business days before use.',
    },
    no_point: {
      title: 'No suitable point at your shoot location? We will search for you.',
      body:  'Draw on the map the area where you are filming and indicate your required capacity and dates. We actively approach owners and grid operators in that area. Within two business days you receive feedback with options.',
      cta:   'Draw an area on the map \\u2192',
    },
    request_cta: 'Submit a request now \\u2192',
  },
  voor_gemeenten: {
    title: 'For government & public sector - Stroomkaart',
    eyebrow: 'For government & public sector',
    h1: 'Make spare capacity visible and use what is already there.',
    lede: 'Existing power connections owned by public authorities often have significant spare capacity, think of event connections or pumping stations. By offering them via Stroomkaart, you relieve the local grid operator and encourage power users in the public space not to rely on generators. Registration is free, and with additional metering services your connections become as easy to use as a public charging point.',
    sec1: {
      eyebrow: 'What it delivers',
      title: 'Benefits for government & public sector.'
    },
    sec2: {
      eyebrow: 'Four steps',
      title: 'How it works.',
      sub: 'NRGmaps is built for asset managers, energy advisors and operations teams within municipalities, provinces and grid operators. You retain full control while making capacity visible.'
    },
    sec3: {
      eyebrow: 'Live in 4 steps',
      title: 'How grid connections gets onto the map.',
      sub: 'The route from first contact to live-on-the-map can be completed within one to two weeks. For more extensive integrations (such as the API link with NRG metering data) we estimate three to four weeks.'
    },
    feat1: {
      title: 'Spare capacity used',
      body: 'Construction cabinets, event connections, pumping stations and street lighting often have spare capacity. Stroomkaart makes this usable for others without losing control.'
    },
    feat2: {
      title: 'Cleaner contractor sites',
      body: 'Connections via Stroomkaart make working on grid power instead of generators easier. Helps achieve emission-free goals in tendering documents and zero-emission policy.'
    },
    feat3: {
      title: 'No own platform needed',
      body: 'No own IT infrastructure, no own request flow. Stroomkaart handles incoming requests; you only review what is relevant for you.'
    },
    opt1: {
      num: 'Option 01',
      title: 'One-off upload',
      effort: 'Effort: medium· Available right away',
      body: 'Already have your connections in a spreadsheet or asset system? Provide an export of your existing connections file and we process it for you. Within a few business days your connections appear on the map.',
      li1: 'Suitable for organisations without real-time metering data.',
      li2: 'Updates happen periodically (manually or via a new upload)',
      li3: 'You change availability yourself in your admin portal',
      li4: 'A good way to gain experience first',
      cta: 'Register directly'
    },
    opt2: {
      num: 'Option 02',
      title: 'Stroomkaart Interactive Map by NRG Group',
      effort: 'Effort low · Real-time & automated',
      body: 'For those who want full insight into their own connections: we link your connections via an API to a digital map layer. Per grid connection you see the available capacity, so internally you also know where spare capacity can be used.',
      li1: 'Answers questions such as: which connections have structural spare capacity, and where are the white spots in the network?',
      li2: 'Insight into spare capacity per hour, day and season',
      li3: 'Automatic refresh via ODA link (small-volume) and API link (large-volume)',
      li4: 'Bespoke setup: standalone NRG web environment, embedded in existing GIS (e.g. ArcGIS), or underlying data via API',
      li5: 'Example case Municipality of Leiden: charging facility on a municipal pumping station - spare capacity used for charging equipment, with the pumping station always taking priority. Cheaper than mobile power sources and lower kWh price than diesel.',
      cta: 'More info on nrggroup.nl'
    },
    step1: {
      num: 'Step 01',
      title: 'Register your connections',
      body: 'Via Excel upload or the NRG metering service. Start small, scale up later.'
    },
    step2: {
      num: 'Step 02',
      title: 'Set your own visibility',
      body: 'For each point you decide whether it is publicly visible and under what conditions. You retain full control.'
    },
    step3: {
      num: 'Step 03',
      title: 'Review requests',
      body: 'Incoming requests are managed centrally in your admin portal: review, approve or reject based on your conditions.'
    },
    step4: {
      num: 'Step 04',
      title: 'Earn from unused capacity',
      body: 'No connection costs, no subscription. You receive a fee per realised connection. Consumption and settlement run automatically.'
    },
    dashboard_callout:   '<strong>One dashboard for all connections.</strong> With the Interactive Stroomkaart you not only see which points are available to others via Stroomkaart, but also which connections within your own organisation have spare capacity. That way you can deploy capacity for projects such as charging infrastructure, zero-emission equipment or events - before applying for new connections.',
    partners_eyebrow:    'A selection of our partners',
    cta_strip: {
      title:     'Ready to register your first power points?',
      sub:       'Two registration paths - one-off Excel upload or the NRG metering service. You decide what fits.',
      primary:   'Register directly',
      secondary: 'Schedule a call first',
    },
  },
  voor_bedrijven: {
    title: 'For businesses - Stroomkaart',
    eyebrow: 'For businesses',
    h1: 'Monetize your grid connections - and make them available to others.',
    lede: 'Real estate managers, supply-chain partners and industrial complexes often have more power capacity than they use daily. NRGmaps helps unlock this spare capacity for projects that need temporary power - with you in control of the conditions.',
    sec1: {
      eyebrow: 'What it delivers',
      title: 'Benefits for businesses.'
    },
    sec2: {
      eyebrow: 'Two registration paths',
      title: 'Two ways to register your connections.',
      sub: 'Whether you want to start small with an export of your existing connections file, or set up an automated link with your large-volume meter directly.'
    },
    feat1: {
      title: 'Monetise spare capacity',
      body: 'Many business connections have more capacity than is used daily. NRGmaps makes this surplus available for projects that need temporary power - with you in control of conditions.'
    },
    feat2: {
      title: 'Full control over conditions',
      body: 'You decide which connections are publicly visible, who can use them and under what conditions.'
    },
    feat3: {
      title: 'No own platform needed',
      body: 'No own IT infrastructure, no own request flow. NRGMaps handles incoming requests; you only review what is relevant.'
    },
    opt1: {
      num: 'Option 01',
      title: 'One-off upload',
      effort: 'Effort: medium · Available right away',
      body: 'Already have your connections in a spreadsheet or asset system? Provide an export of your existing connections file and we process it for you. Within a few business days your connections appear on the map.',
      li1: 'Suitable for businesses without real-time metering data',
      li2: 'Updates happen periodically (manual or via a new upload)',
      li3: 'Availability is tracked by Stroomkaart',
      li4: 'A good way to gain experience first',
      cta: 'Register directly'
    },
    opt2: {
      num: 'Option 02',
      title: 'Automatic API link',
      effort: 'Effort: low · Automated',
      body: 'For businesses wanting to display continuously up-to-date data: NRG Group links your small-volume connections via ODA and your large-volume meter via a direct API connection. Available capacity and status are shown automatically and in real time on the map, without you having to set up your own monitoring or IT infrastructure.',
      li1: 'Real-time status on the map - management and requests are handled by the Stroomkaart team.',
      li2: 'ODA link for small-volume connections, API link for large-volume meters',
      li3: 'Insight into spare capacity per hour, day and season - useful for offering free capacity intelligently',
      li4: 'Part of the digital Stroomkaart service by NRG Group',
      cta: 'More info on nrggroup.nl'
    },
    callout: '<strong>You set the conditions - we handle the management.</strong> Per connection you decide whether it is publicly visible on the map, or only accessible within your own network. The Stroomkaart team handles incoming requests based on criteria agreed with you in advance (project, capacity, requested period, certifications, insurance requirements).',
    cta: {
      title:     'Ready to unlock your unused capacity?',
      sub:       'Two connection methods, full control over conditions and visibility. The Stroomkaart team handles requests for you.',
      primary:   'Register directly',
      secondary: 'Contact',
    },
  },
  voor_laadpalen: {
    title: 'For municipalities & EV charging operators - Stroomkaart',
    eyebrow: 'For municipalities & EV charging operators',
    h1: 'Make charging stations findable for construction, events and other power requesters.',
    lede: 'In addition to EV drivers, construction companies, event organizers and film sets can also use public charging stations. NRGmaps helps make these charging stations visible and safely deployable for these new audiences.',
    sec1: {
      eyebrow: 'What it delivers',
      title: 'Benefits for users, municipalities and charging operators.'
    },
    sec2: {
      eyebrow: 'Four steps',
      title: 'How it works.',
      intro: 'Public charging stations are designed to charge electric vehicles. For use by other audiences, a few technical principles apply.'
    },
    sec3: {
      eyebrow: 'Realistic scope',
      title: 'What does and does not fit on a charging station?',
      sub: 'A public charging station typically delivers 11kW per socket. That is enough for light electric equipment, EV vans and small mobile power needs - but not for tower cranes, large stages or industrial draw.'
    },
    sec4: {
      eyebrow: 'Four steps',
      title: 'How it works.',
      sub: 'Using a public charging station requires coordination between three parties: the user, the municipality (or client) and the CPO (the operator of the charging point). NRGmaps facilitates this coordination.'
    },
    sec5: {
      eyebrow: 'Frequently asked questions',
      title: 'What contractors and municipalities often want to know.'
    },
    feat1: {
      title: 'New user groups',
      body: 'Beyond EV drivers: contractors with electric equipment, event organisers and filmsets. NRGmaps routes them to your charging stations when there is capacity.'
    },
    feat2: {
      title: 'Quieter and cleaner for nearby residents',
      body: 'Less noise and exhaust nuisance in urban areas. Prevents complaints and fits requirements for emission-free construction sites.'
    },
    feat3: {
      title: 'Quick to deploy',
      body: 'The charging station is already there. With a construction charging card and the right adapter, you can often get started plug-and-play within one working day.'
    },
    step1: {
      num: 'Step 01',
      title: 'Search & verify',
      body: 'Filter by type "Charging station" on the map and check which stations are around your location.'
    },
    step2: {
      num: 'Step 02',
      title: 'Make arrangements',
      body: 'We arrange permission with the municipality and the CPO.'
    },
    step3: {
      num: 'Step 03',
      title: 'Construction charging card & adapter',
      body: 'You receive a construction charging card and, if needed, a safe adapter for equipment without a type 2 plug.'
    },
    step4: {
      num: 'Step 04',
      title: 'Connect and start',
      body: 'Hold the card to the station, plug in the cable, done. One invoice per project.'
    },
    cta: {
      title: 'Curious if this fits your project?',
      sub:   'Open the map, or schedule five minutes with our project coordinator to run the numbers.',
      cta1:  'View charging stations',
      cta2:  'Schedule a call',
    },
    faq: {
      q1: 'Am I even allowed to use a public charging station for construction work?',
      a1: 'Yes, with permission from the owner of the charging point (the CPO) and in coordination with the municipality. Stroomkaart arranges this coordination per project.',
      q2: 'What is a construction charging card and do I really need one?',
      a2: 'Yes, the construction charging card secures registration of this type of use.',
      q3: 'When do I need an adapter?',
      a3: 'Only if your equipment does not have a type 2 plug according to the mode 3 protocol. Important: do not use a random adapter. Adapters on the market that do not comply with safety guidelines can cause dangerous situations. We supply an adapter that complies with the applicable guidelines.',
      q4: 'What if the charging station is further from the construction site?',
      a4: 'Using charging stations further from the construction site is custom work. Contact us to explore the possibilities.',
      q5: 'What power can I expect?',
      a5: 'Public charging stations typically deliver up to 11 kW per socket. That is enough for smaller and stationary equipment - site huts, tools, light machinery, charging electric vans.',
      q6: 'What if the charging station breaks due to misuse?',
      a6: 'The user is responsible for safe connection and disconnection and for protecting the charging station during use. In case of damage, repair or replacement costs are charged to the user.',
      q7: 'Will EV drivers not be hindered?',
      a7: 'In many cases not, since the charging station is not accessible to regular EVs when the street is closed off.',
    },
    no_point: {
      title: 'No charging station nearby? We help you think.',
      body:  'Sometimes there are no or not enough charging stations on or near your construction site. The municipality may consider placing charging stations where EV drivers will want to charge after the construction. We help guide such proposals from Stroomkaart.',
      cta:   'Plan an exploration →',
    },
    request_cta:   'Submit a request directly →',
    situation1: {
      label: 'Situation 1 - Equipment with type 2 plug',
      title: 'Connect directly',
      body:  'Equipment that has its own <strong>type 2 plug</strong> following the <strong>mode 3 protocol</strong> (the standard for public charging) can be connected directly to a public charging station, just like an electric car. The charging station and the equipment communicate to set the correct charging current.',
    },
    situation2: {
      label: 'Situation 2 - Equipment without type 2 plug',
      title: 'Connect with a safe charging adapter',
      body:  'For equipment without a type 2 plug, an adapter is required. Important: not all adapters on the market meet the safety requirements. Always use an adapter that complies with the NKL requirements to avoid dangerous situations and damage to the charging infrastructure.',
    },
    adapter_cta:   'Request the NRG adapter →',
    bouwlaadpas:   '<strong>The construction charging card.</strong> With a construction charging card you activate the charging station, and we can, in coordination with the CPO, disable settings that hinder continuous power draw, such as smart charging.',
    bouwlaadpas_cta: 'Request a charging card →',
    fits: {
      label: 'Fits on a charging station',
      l1: 'Site huts, canteens, construction lighting',
      l2: 'Hand tools and smaller stationary equipment',
      l3: 'Charging electric vans and construction trucks',
      l4: 'Small electric equipment (mini excavator, scaffolding lift, electric pump)',
      l5: 'Temporary security cameras and sensors',
    },
    notfits: {
      label: 'Request or look for a power point with more capacity',
      l1: 'Equipment such as tower cranes with high startup current',
      l2: 'Continuous power demand from heating or large pumps with constant draw above 32A.',
      l3: 'Equipment with battery capacity over 200 kWh.',
    },
    notsure:       '<strong>Not sure?</strong> Contact us and we will work out the power demand together.',
    feat4: {
      title: 'Extra income for operators',
      body:  'Earn on charging infrastructure that is temporarily not being used by EV drivers. Idle hours still generate revenue without any extra investment.',
    },
    nkl_link:      'Read the full NKL handbook →',
    nkl_url:       'https://nklnederland.nl/the-netherlands-knowledge-platform-for-charging-infrastructure/',
    flyer_cta:     'Download the flyer (PDF)',
    flyer_url:     'assets/flyers/adapter-brochure-en.pdf',
  },
};
